import React from 'react'

const Project = () => {
  return (
<>  {/* About Project Section */}
      <div
        id="about"
        className="min-h-screen flex flex-col items-center justify-center gap-16 px-6 lg:px-16 bg-gray-100 dark:bg-gray-800 text-black dark:text-white"
      >
        <h1 className='text-3xl font-bold mt-20 text-center'>All <span className='text-red-500 '>About</span> Me And My <span className='text-red-500 '>Experience</span></h1>

       
       <div className='flex flex-col lg:flex-row items-center justify-center'>
       <div className="">
       <img
          src="/profile.jpg"
          alt="Project Screenshot"
            className="rounded-lg shadow-lg max-h-96"
          />
        
        </div>

     
     
      <div
        data-aos="zoom-in"
        className=" p-8 rounded-xl max-w-3xl w-full"
      >
        <ul className="space-y-6 text-lg font-medium text-gray-800 dark:text-gray-200">
          <li className="flex items-start space-x-3">
            <span className="text-lg font-semibold text-red-500 dark:text-red-400">Hello!</span>
            <p>
              My name is Nilesh Raut & I am skilled in development, logical thinking, and content writing, and I manage multiple blogging sites. I am a Full-Stack Developer with a strong foundation in DSA.
            </p>
          </li>

          <li className="flex items-start space-x-3">
            <span className="text-lg font-semibold text-red-500 dark:text-red-400">Experience:</span>
            <p>
            I have great experience in Full-Stack Web Development,completed multiple projects. I also solved over 300+ DSA problems on LeetCode, strengthening my problem-solving skills.            </p>
          </li>

          <li className="flex items-start space-x-3">
            <span className="text-lg font-semibold text-red-500 dark:text-red-400">Current Role:</span>
            <p>
              Fast forwarding to today, I am working as a GET at JIO Platform Limited's 
            </p>
          </li>
        </ul>
      </div>
    </div>
       
      </div></>
  )
}

export default Project